const KEY_PREFIX = "upsider_pref";

export function getUserScopedKey(userId: string, key: string): string {
  return `${KEY_PREFIX}:${userId}:${key}`;
}
